import React, { useState, useEffect, useRef } from 'react'
import { cmToIn } from '@helpers/utils'
import Translations from '@helpers/translations'
import { TOPS } from '@consts/index'
import SizeChartTableInternational from '@components/pages/static/SizeChart/SIzeChartTableSelector/SizeChartTableInternational'
import FitOption from '@components/ui/FitOption'
import styles from './styles.module.scss'
import sizeChartTableStyles from '../styles.module.scss'
import { InternationalTableRowsProperties } from '..'

const SIZE_TYPES = [
  'Actual waist',
  'Waist relaxed',
  'Front rise',
  'Back rise',
  'Hip',
  'Thigh'
]

const getFilterLabelName = (productCategory: string) => {
  if (/tops/.test(productCategory)) {
    return 'size'
  }
  return 'waist'
}

type SizeChartTablesMobileProps = {
  productCategory: string
  sizeChartColumn: string[]
  sizeChartBuild: string[][]
  measurementType: number
  internationalTableRows: InternationalTableRowsProperties[]
  hasSizeChartTableData: boolean
}

const SizeChartTablesMobile = ({
  productCategory,
  sizeChartColumn,
  sizeChartBuild,
  measurementType,
  internationalTableRows,
  hasSizeChartTableData
}: SizeChartTablesMobileProps) => {
  const [{ selectedSize, sizeValueIndex }, setSelectedSize] = useState({
    selectedSize: sizeChartColumn[0],
    sizeValueIndex: 1
  })
  const extraText = useRef('')

  useEffect(() => {
    extraText.current = ''
    const columnIndex = productCategory === TOPS ? 3 : 1
    setSelectedSize({
      selectedSize: sizeChartColumn[columnIndex],
      sizeValueIndex: columnIndex - 1 // decrease index as "sizeChartColumn" first index is not waist value, but waist name "Waist" in the array
    })
  }, [sizeChartColumn, productCategory])

  const internationalTableData = internationalTableRows.map(
    ({ name, values }) => {
      return {
        name,
        values: [values[sizeValueIndex]]
      }
    }
  )

  const waistList = sizeChartColumn?.filter(item => item) || []
  const tableList = sizeChartBuild?.filter(item => item) || []

  return (
    <div className={styles.sizeChart__mobile}>
      {hasSizeChartTableData ? (
        <>
          <h3 className={sizeChartTableStyles.sizeChart__mobile__title}>
            {Translations.localise(
              `pages.size-chart.label-${getFilterLabelName(productCategory)}`
            )}
          </h3>
          <ul className={styles.sizeChart__options}>
            {waistList.slice(1, sizeChartColumn.length).map((item, i) => (
              <li key={item}>
                <FitOption
                  optionValue={`${item}`}
                  onSelect={() =>
                    setSelectedSize({
                      selectedSize: item,
                      sizeValueIndex: i
                    })
                  }
                  selected={item === selectedSize}
                  active
                />
              </li>
            ))}
          </ul>
        </>
      ) : null}

      <h3 className={sizeChartTableStyles.sizeChart__mobile__title}>
        {Translations.localise(
          'pages.size-chart.label-international-measurements'
        )}
      </h3>
      <SizeChartTableInternational rows={internationalTableData} />
      {hasSizeChartTableData ? (
        <>
          <h3 className={sizeChartTableStyles.sizeChart__mobile__title}>
            {Translations.localise(
              'pages.size-chart.label-product-measurements'
            )}
          </h3>
          <ul className={styles.sizeChart__lines}>
            {tableList.map((tableItem, i) => {
              const value = tableItem[sizeChartColumn.indexOf(selectedSize)]
              const measured =
                measurementType === 2 && typeof value === 'number'
                  ? cmToIn(value)
                  : value
              if (
                [
                  '3/" LEG',
                  '5/" LEG',
                  '7/" LEG',
                  '9/" LEG',
                  '11/" LEG'
                ].includes(tableItem[0])
              ) {
                extraText.current = tableItem[0]

                return null
              }

              // prevents the addition of leg length before the size name
              const name = `${
                SIZE_TYPES.includes(tableItem[0])
                  ? ''
                  : extraText.current.replace('/', '').replace('LEG', ' - ')
              }${tableItem[0]}`
              return (
                <li key={`szul${i}`} className={styles.sizeChart__line}>
                  {name}
                  <span className={styles.sizeChart__detail}>{measured}</span>
                </li>
              )
            })}
          </ul>
        </>
      ) : null}
    </div>
  )
}

export default SizeChartTablesMobile
